"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapTransform = void 0;
exports.map = map;
var _nodeStream = require("node:stream");
class MapTransform extends _nodeStream.Transform {
  constructor(mapFn, options = {}) {
    super({
      objectMode: true,
      ...options
    });
    this.mapFn = mapFn;
  }
  _transform(chunk, _encoding, callback) {
    try {
      this.push(this.mapFn(chunk));
      callback();
    } catch (error) {
      callback(error);
    }
  }
}
exports.MapTransform = MapTransform;
function map(callback) {
  return new MapTransform(callback);
}